import { DateTime } from 'luxon';

import { Iso8601DateString } from 'lib/types';

interface FormDateValue {
  month: number;
  day: number;
  year: number;
}

const isMoreThanAYearAgo = (value: FormDateValue | Iso8601DateString | null) => {
  if (!value) {
    return false;
  }
  // When it's an ISO string, use the fromISO method instead
  if (typeof value === 'string') {
    return DateTime.local().diff(DateTime.fromISO(value), 'years').years > 1;
  }
  // When it's an object, use the object
  return DateTime.local().diff(DateTime.fromObject(value), 'years').years > 1;
};

export default isMoreThanAYearAgo;
